// extracted by mini-css-extract-plugin
export default {"card":"Card_card__kehOD","cardHeading":"Card_cardHeading__vXMjs","cardContent":"Card_cardContent__XgVuH"};